import { gql } from 'graphql-request';

export const getInvestorDraftProjectFundFilesQuery = gql`
  query serverFilesDraftProjectFundInvestor($input: GetInvestorPublicProjectFundFileInput!) {
    getInvestorDraftProjectsFundsFiles(input: $input) {
      id
      fileName
      content
      createdAt
      updatedAt
      thumbnail
      shared
      status
      size
      url
      projectId
      fundId
      portfolioId
      offeringId
      operatorId
      tags {
        extra
        value
        type
        hidden
        legalEntityId
      }
      locations {
        entityId
        entityType
        locationInPage
        locationInnerId
        sortIndex
      }
      version
    }
  }
`;
